/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Load_ButtonInputs */

const en_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load`)
};

const fr_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger`)
};

const de_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden`)
};

const it_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carico`)
};

const ru_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нагрузка`)
};

const es_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

const zh_cn2_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载`)
};

const ja_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`負荷`)
};

const hi_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भार`)
};

const pt_pt2_audio_description_export_load_button = /** @type {(inputs: Audio_Description_Export_Load_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar`)
};

/**
* | output |
* | --- |
* | "Load" |
*
* @param {Audio_Description_Export_Load_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_load_button = /** @type {((inputs?: Audio_Description_Export_Load_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Load_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_load_button(inputs)
	if (locale === "de") return de_audio_description_export_load_button(inputs)
	if (locale === "it") return it_audio_description_export_load_button(inputs)
	if (locale === "ru") return ru_audio_description_export_load_button(inputs)
	if (locale === "es") return es_audio_description_export_load_button(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_load_button(inputs)
	if (locale === "ja") return ja_audio_description_export_load_button(inputs)
	if (locale === "hi") return hi_audio_description_export_load_button(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_load_button(inputs)
	return en_audio_description_export_load_button(inputs)
});